export default "/static/attune_nxt_tiny.png";